// extracted by mini-css-extract-plugin
module.exports = {"divspacing":"privacy_divspacing__3Viez","alignleft":"privacy_alignleft__3BTjU"};